import React from 'react';

// components
import {
    dibsGalleryName,
    dibsStreetAddress,
    dibsCityStateAddress,
} from '../messages/pdpDetailsMessages';

function PdpSharedDetailItemLocation() {
    return (
        <span data-tn="pdp-spec-item-location">
            <p>{dibsGalleryName}</p>
            <p>{dibsStreetAddress}</p>
            <p>{dibsCityStateAddress}</p>
        </span>
    );
}

export default PdpSharedDetailItemLocation;
